import { clientI18n } from '../../../../shared/scripts/ClientI18n.ts';
import { UIRoomUserList } from '../../../../shared/scripts/ui_html/room/UIRoomUserList.ts';
import { showBotEditProfileDialog, showPlayerEditProfileDialog } from '../../../../shared/scripts/ui_popup/edit_profile_dialog/showEditProfileDialog.ts';
import { socket } from '../../../../shared/scripts/EntryShared.ts';
export class UIWRoomUserListController extends UIRoomUserList {
    update(newRoomState) {
        this.updateHeaderView(newRoomState.getSessionCount(), newRoomState.gameSetting.maxPlayers);
        super.update(newRoomState);
    }
    updateHeaderView(sessionCount, maxPlayers) {
        const newText = clientI18n.t('strings:roomPage.notifications.playerCount', {
            count: sessionCount,
            maxCount: maxPlayers
        });
        if (this.header.innerText != newText) this.header.innerText = newText;
    }
    // eslint-disable-next-line class-methods-use-this
    openEditProfileForPlayer(player) {
        if (player === null || player === void 0 ? void 0 : player.isBot) {
            showBotEditProfileDialog({
                selectColorAction: async (color)=>{
                    if (player == undefined) return;
                    socket.roomClient.selectColor(player.roomSessionId, color);
                },
                selectedColor: player.selectedColor,
                username: player.username
            });
            return;
        }
        showPlayerEditProfileDialog({
            selectColorAction: async (color)=>{
                if (player == undefined) return;
                socket.roomClient.selectColor(player.roomSessionId, color);
            },
            selectedColor: player === null || player === void 0 ? void 0 : player.selectedColor
        });
    }
    constructor(){
        super(document.getElementById('scene_room_player_list'));
        this.header = document.getElementById('scene_room_left_header');
    }
}
